<template>
  <button class="relative isolate cursor-pointer">
    <label for="accountDrawerTrigger" class="absolute inset-0 z-10 cursor-inherit"></label>
    <input id="accountDrawerTrigger" type="checkbox" class="absolute opacity-0 w-0 h-0" v-if="!!props.injectInput" />
    <ClientOnly>
      <NuxtImg
        loading="lazy"
        :src="isUserLoggedIn ? '/icons/user-logged.svg' : '/icons/profile.svg'"
        alt="Patient Login"
        width="22"
        height="25"
        :class="props.iconClass"
      />
      <template #fallback>
        <NuxtImg
          loading="lazy"
          src="/icons/profile.svg"
          alt="Patient Login"
          width="22"
          height="25"
          :class="props.iconClass"
        />
      </template>
    </ClientOnly>
  </button>
</template>

<script setup lang="ts">
interface AccountTriggerProps {
  injectInput?: boolean;
  iconClass?: string;
}

const props = withDefaults(defineProps<AccountTriggerProps>(), {
  injectInput: false,
});

const profileStore = useProfileStore();
const isUserLoggedIn = computed(() => {
  return profileStore.loggedIn;
});
</script>
